import React, {useState, useEffect} from 'react';
import {
    Box,
    Button,
    TextField,
    MenuItem,
    CircularProgress,
    Typography,
    FormControlLabel,
    Switch,
} from '@mui/material';
import {toast} from 'react-toastify';
import {adminApi} from 'utils/api';

export default function RemoteTab() {
    const [form, setForm] = useState({
        ip: '',
        port: 22,
        username: '',
        password: '',
        protocol: 'ssh',
        workDir: '',
        enabled: false,
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const fetchTarget = async () => {
        try {
            const res = await adminApi.getRemoteTarget();
            const t = res.data.target || {};
            setForm({
                ip: t.ip || '',
                port: t.port || 22,
                username: t.username || '',
                password: t.password || '',
                protocol: t.protocol || 'ssh',
                workDir: t.workDir || '',
                enabled: !!t.enabled,
            });
        } catch (err) {
            toast.error('원격 타겟 정보를 불러오지 못했습니다.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTarget();
    }, []);

    const handleChange = (field) => (e) => {
        setForm(prev => ({...prev, [field]: e.target.value}));
    };

    const handleSave = async () => {
        if (!form.ip.trim() || !form.username.trim()) {
            toast.warning('IP와 사용자명은 필수입니다.');
            return;
        }
        setSaving(true);
        try {
            await adminApi.saveRemoteTarget(form);
            toast.success('원격 타겟이 저장되었습니다.');
        } catch (err) {
            toast.error(err.response?.data?.error || '저장 실패');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <Box sx={{display: 'flex', justifyContent: 'center', py: 4}}><CircularProgress/></Box>;
    }

    return (
        <Box>
            <Typography variant="h6" sx={{mb: 2}}>원격 빌드 타겟</Typography>

            <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={form.enabled}
                            onChange={(e) => setForm(prev => ({...prev, enabled: e.target.checked}))}
                        />
                    }
                    label={form.enabled ? '활성 (원격 빌드 사용)' : '비활성 (로컬 빌드 사용)'}
                />

                <Box sx={{display: 'flex', gap: 2}}>
                    <TextField
                        size="small"
                        label="IP"
                        value={form.ip}
                        onChange={handleChange('ip')}
                        placeholder="예: 192.168.0.10"
                        disabled={!form.enabled}
                        fullWidth
                        sx={{flex: 2}}
                    />
                    <TextField
                        size="small"
                        type="tel"
                        label="포트"
                        value={form.port}
                        onChange={handleChange('port')}
                        placeholder="22"
                        disabled={!form.enabled}
                        fullWidth
                        sx={{flex: 1}}
                    />
                    <TextField
                        select
                        size="small"
                        label="프로토콜"
                        value={form.protocol}
                        disabled
                        fullWidth
                        sx={{flex: 1}}
                    >
                        <MenuItem value="ssh">SSH</MenuItem>
                    </TextField>
                </Box>

                <Box sx={{display: 'flex', gap: 2}}>
                    <TextField
                        size="small"
                        label="사용자명"
                        value={form.username}
                        onChange={handleChange('username')}
                        disabled={!form.enabled}
                        fullWidth
                        sx={{flex: 1}}
                    />
                    <TextField
                        size="small"
                        type="password"
                        label="비밀번호"
                        value={form.password}
                        onChange={handleChange('password')}
                        disabled={!form.enabled}
                        fullWidth
                        sx={{flex: 1}}
                    />
                </Box>

                <TextField
                    size="small"
                    label="작업 경로"
                    value={form.workDir}
                    onChange={handleChange('workDir')}
                    placeholder="원격 서버의 빌드 작업 디렉토리 (예: /home/user/into-build)"
                    disabled={!form.enabled}
                    fullWidth
                />
            </Box>

            <Box sx={{display: 'flex', justifyContent: 'flex-end', mt: 3}}>
                <Button
                    variant="contained"
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saving ? '저장 중...' : '저장'}
                </Button>
            </Box>
        </Box>
    );
}
